const ALWAYS_FORMULA_CHARS = ['=', '@', '\t', '\r'];
const SIGN_CHARS = ['+', '-'];
const NUMBER_OR_PHONE = /^[+\-.,()/\d ]*\d[+\-.,()/\d ]*$/;

export function sanitizeExcelCell<T>(value: T): T | string {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }

  const first = value[0];

  if (ALWAYS_FORMULA_CHARS.includes(first)) {
    return `'${value}`;
  }

  if (SIGN_CHARS.includes(first) && !NUMBER_OR_PHONE.test(value)) {
    return `'${value}`;
  }

  return value;
}